import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

// Components
import Header from './components/Header'
import CoreLayout from './components/CoreLayout'
import Loader from '../../components/Loader'
import axios from 'axios'

// Scenes
class User extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      loadingIteration: 0,
      data: [],
      id: ''
    }
  }

  getData() {
    let currentComponent = this
    var pathArray = window.location.pathname.split('/')
    var id = pathArray[pathArray.length - 1]

    this.setState({
      id: id,
      loaded: false
    })

    if (id != null && id.length <= 6) {
      axios
        .get(
          'https://api.dsnapis.com/candidate/' +
            id +
            '/pw/teSt1/ssrch/1/db/2/cust/' +
            this.props.customer_number
        )
        .then(function(response) {
          if (response.data) {
            if (Array.isArray(response.data)) {
              // Retrieved Data.
              if (response.data.length == 0) {
                alert('This profile is not active.')
                currentComponent.props.changeRoute(
                  '/console/search/search_by_name'
                )
              } else {
                currentComponent.setState({
                  data: response.data[0],
                  loaded: true
                })
              }
            } else {
              currentComponent.getData()
            }
          } else {
            currentComponent.getData()
          }
          /*
        if(response.data[0]) {
          //alert(JSON.stringify(response.data[0]["Pic1"]))
          if (Array.isArray(response.data)){
            currentComponent.setState({
              data: response.data[0],
              loaded: true
            });
          } else {
            currentComponent.props.changeRoute("/console/search/search_by_name")
            alert("This profile is not active.")

          }
        } else {
          currentComponent.props.changeRoute("/console/search/search_by_name")
          alert("This profile is not active.")

        }*/
        })
    } else {
      currentComponent.props.changeRoute('/console/search/search_by_name')
      alert('This profile is not active.')
    }
  }

  componentDidMount() {
    this.getData()
  }

  render() {
    const { classes, theme, location } = this.props
    const { data, id } = this.state

    var pathArray = window.location.pathname.split('/')
    var idtop = pathArray[pathArray.length - 1]

    if (id != idtop) {
      this.getData()
    }

    if (this.state.loaded) {
      return (
        <div>
          <Header />
          <CoreLayout data={data} />
        </div>
      )
    } else {
      return <Loader />
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(User)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/index.js